import { Preferences } from "../../profile/objects/preferences";
import { CENTRAL_PAYMENT_MARGIN_MODULE, MARGIN_COLUMN } from "../constant/centralPaymentConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setMarginPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: CENTRAL_PAYMENT_MARGIN_MODULE,
        default_columns: MARGIN_COLUMN,
        default_order_by: '-created_date',
    });
